import GetAccessTo from '../../components/shared/GetAccessTo';
import FirstNameStep from '../../steps/FirstNameStep';
import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import { OnboardingNode } from '../../types';

export const FIRST_NAME_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.FIRST_NAME,
  options: { countsTowardProgressBar: false, hideProgressBar: true, optional: true },
  elements: [
    {
      uid: OnboardingStepType.FIRST_NAME,
      component: (
        <FirstNameStep
          uid={OnboardingStepType.FIRST_NAME}
          nodeType={OnboardingNodeType.FIRST_NAME}
          displayName="Name & Email"
          actionButtonText="Continue"
        />
      ),
      additionalContent: <GetAccessTo />
    }
  ]
};
